export const parseErrorResponse = async (response) => {
  try {
    const data = await response.json();
    if (typeof data?.detail === 'string') {
      return { code: null, message: data.detail };
    }

    const nestedError = data?.detail?.error || data?.error;
    if (nestedError && typeof nestedError?.message === 'string') {
      return {
        code: nestedError?.code || null,
        message: nestedError.message,
      };
    }

    return { code: null, message: `HTTP error! status: ${response.status}` };
  } catch {
    return { code: null, message: `HTTP error! status: ${response.status}` };
  }
};

const TERMINAL_SWARM_STATES = new Set(['completed', 'stopped']);

export const isTerminalState = (state) => TERMINAL_SWARM_STATES.has(state);

export const getSummaryIdentity = (summary) => {
  if (!summary || typeof summary !== 'object') return null;
  const summaryId = typeof summary.summary_id === 'string' ? summary.summary_id.trim() : '';
  if (summaryId) return `id:${summaryId}`;
  const turn = Number.isFinite(summary.final_turn) ? summary.final_turn : 'na';
  const isFinal = summary.is_final === true ? '1' : '0';
  const generatedAt = typeof summary.generated_at === 'string' ? summary.generated_at : 'na';
  return `legacy:${turn}:${isFinal}:${generatedAt}`;
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result || '';
      const base64String = String(result).split(',')[1] || '';
      resolve({
        name: file.name,
        content: base64String,
        media_type: file.type,
      });
    };
    reader.onerror = (error) => reject(error);
  });
};
